import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import toastr from "../../../components/elements/toast";
import { getStorageValue } from "../../../service/shared.service";
import { handleInput } from "../../../service/common_function";
import httpApiCall from "../../../service/api.service";
import { folder } from "../../../assets/assets";
import "../../../components/Assests/MyAssets/MyAssets.scss";
import { setShowAssets } from "../../../Redux/Slices/MainSlice";
import { Spinner } from "react-bootstrap";

const toastrService = new toastr(true);
const token = getStorageValue("partnerToken");

let profileData = getStorageValue("partnerProfile");
profileData = profileData && profileData[0];

const  Folder = (props: any) => {
  const [sppiner, setSppiner] = useState(false);
  const AssestsFolderDataRedux = useSelector(
    (state: any) => state?.AssetsData?.addAssestsFolder
  );
  // console.log(AssestsFolderDataRedux.value,"AssestsFolderDataRedux");
  // console.log(props.folderName,"props.folderName");
  
  // console.log(props,"props");
  
  // console.log(props.folderId,"folderIdfolderIdfolderIdfolderId");
  
  // console.log(props.onHide);
  const [createFolderForm, setCreateFolderForm] = useState({
    folderName:  props.folderName ? props.folderName : props.createFolderForm ? props.createFolderForm?.name :"",
  });

  if (props.createFolderForm) {
    // console.log(props.createFolderForm,"iiiiiiiiiii");

    // setCreateFolderForm({createFolderForm})
  }
  // const [partnerAssetsFolderId, setPartnerAssetsFolderId] = useState();
  // const dispatch = useDispatch();

  const handleSubmit = async (formData?: any) => {
    // props.hideFolders(formData.folderName);
    if (props.subId) {
      addFolder({ folderName: formData.folderName });
    } else {
      editFolder({ folderName: formData.folderName });
    }
  };
  const addFolder = async ({ folderName }: any) => {
    setSppiner(true);
    const response = await addFolderApi({
      folderName: folderName,
      type: props.type,
      folderId: props.folderId,
    });
    setSppiner(false);
    if (response) {
      props.onHide();
      // dispatch(setShowAssets(false));
      
      if (props.folderId== 0) {
        props.getFolders();

      } else {
        props.getAllFilesData(props.folderId);

      }
    }
  };

  const editFolder = async ({ folderName }: any) => {
    setSppiner(true);
    let folderRename = props.nameExt ? folderName + "." + props.nameExt : folderName; 
    const response: any = await editFolderApi({
      folderName : folderRename,
      fileType: props.fileType,
      editFileld: props.editFileld,
      type: props.type,
      folderId: props.folderId,
    });
    setSppiner(false);
    if (response && response.is_error == 0) {
      props.onHide();
      if (folderName && folderName.length) {
        props.getFolders();
      } else {
        props.getAllFilesData(props.folderId || 0 ,1);
      }
      // this.deleteFolder.hide();
    }
  };

  const validationSchema = Yup.object({
    folderName: Yup.string().required("Please enter valid name."),
  });

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="pt-0 border-bottom" >
        <Modal.Title id="contained-modal-title-vcenter">
          <h1>
            <span>
              <img src={folder} alt="" />
            </span>
            Add Folder
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          onSubmit={handleSubmit}
          initialValues={createFolderForm}
          validationSchema={validationSchema}
        >
          <Form className="-modal-content folder">
            {/* <div className="folder--header">
            <div className="left">
              
              <span>{props.editFolderData?.folder_name}</span>
            </div>
            <svg
              onClick={props.onHide}
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="33"
              viewBox="0 0 34 33"
              fill="none"
            >
              <path
                d="M17.0026 30.25C24.7943 30.25 31.1693 24.0625 31.1693 16.5C31.1693 8.9375 24.7943 2.75 17.0026 2.75C9.21094 2.75 2.83594 8.9375 2.83594 16.5C2.83594 24.0625 9.21094 30.25 17.0026 30.25Z"
                fill="white"
              />
              <path
                d="M23.3841 21.4628L18.3063 16.3851L23.3841 11.3073C23.5065 11.1849 23.5753 11.0188 23.5753 10.8457C23.5753 10.6726 23.5065 10.5065 23.3841 10.3841C23.2617 10.2617 23.0956 10.1929 22.9225 10.1929C22.7493 10.1929 22.5833 10.2617 22.4609 10.3841L17.3831 15.4618L12.3054 10.3841C12.1829 10.2617 12.0169 10.1929 11.8437 10.1929C11.6706 10.1929 11.5046 10.2617 11.3821 10.3841C11.3199 10.4418 11.2707 10.5122 11.2379 10.5905C11.2052 10.6689 11.1896 10.7533 11.1922 10.8382C11.1948 10.923 11.2156 11.0063 11.2531 11.0825C11.2907 11.1586 11.3441 11.2259 11.4098 11.2796L16.4876 16.3574L11.3821 21.4628C11.2597 21.5853 11.1909 21.7513 11.1909 21.9244C11.1909 22.0976 11.2597 22.2636 11.3821 22.3861C11.5046 22.5085 11.6706 22.5773 11.8437 22.5773C12.0169 22.5773 12.1829 22.5085 12.3054 22.3861L17.3831 17.3083L22.4609 22.3861C22.5833 22.5085 22.7493 22.5773 22.9225 22.5773C23.0956 22.5773 23.2617 22.5085 23.3841 22.3861C23.5065 22.2636 23.5753 22.0976 23.5753 21.9244C23.5753 21.7513 23.5065 21.5853 23.3841 21.4628Z"
                fill="#A2A8B0"
              />
            </svg>
          </div> */}
            <div className="folder--content">
              <div className="userflow-input">
                <label> Name</label>

                <Field
                  className="form-control"
                  type="text"
                  autoComplete="_away"
                  name="folderName"
                  maxLength={50}
                  onKeyDown={handleInput}
                />
                <small className="text-danger m-2">
                  <ErrorMessage name="folderName" />
                </small>
              </div>
              <button disabled={sppiner} className="button" type="submit">
                Submit
                {sppiner && (
                  <Spinner
                    className="ml-2"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </button>
            </div>
          </Form>
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default Folder;

const addFolderApi = async ({ folderName, type, folderId }: any) => {
  try {
    let body = {
      access_token: token,
      partner_id: profileData.partner_id,
      folder_name: folderName,
      partner_assets_folder_id: type == 2 ? folderId : 0,
    };
    const res = await httpApiCall({
      api: "add_assets_folder",
      type: "post",
      body,
    });

    if (res.is_error == 0) {
      toastrService.showSuccess("Folder Created");
      return res;
    } else {
      toastrService.showError(res.err);
    }
  } catch (error) {
    toastrService.showError(error);
  }
};

const editFolderApi = async ({
  folderName,
  fileType,
  editFileld,
  type,
  folderId,
}: any) => {
  try {
    let body = {
      access_token: token,
      partner_id: profileData.partner_id,
      type: fileType,
      assets_file_id: editFileld,
      partner_assets_folder_id: type == 2 ? folderId : 0,
      assets_file_name: folderName,
    };
    if (fileType == 1) {
      // body['assets_file_name'] =  body['assets_file_name'] + '.' + name_ext;
    }
    const respone = await httpApiCall({
      api: "edit_assets_file",
      type: "post",
      body,
    });

    if (respone && respone.is_error == 0) {
      toastrService.showSuccess("Folder Updated");
      return respone;
    } else {
      toastrService.showError(respone.err);
    }
  } catch (error) {
    toastrService.showError(error);
  }
};
